import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchPaymentHistory = async (token) => {
  const res = await axios.get(`${baseUrl}/paymentHistotyApi/?portal=${portal}`, {
    headers: { Authorization: `Token ${token}` }
  });
  return res.data;
}